import React from "react";
import Pricing from "../Home/Pricing";
import Footer from "../Home/Footer";

function PricingPage() {
  return (
    <>
      <Pricing standalone />
      <Footer />
    </>
  );
}

export default PricingPage;
